import { AlertCircle, RefreshCw, ChevronLeft } from 'lucide-react';


const NotFoundGraphic = () => (
  <div className="flex flex-col items-center mb-6">
    {/* SVG illustration for 404 */}
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="60" cy="60" r="56" fill="#e0e7ef" />
      <text x="50%" y="54%" textAnchor="middle" fill="#3b82f6" fontSize="48" fontWeight="bold" dy=".3em">404</text>
      <ellipse cx="60" cy="90" rx="28" ry="6" fill="#cbd5e1" />
    </svg>
  </div>
);

interface ErrorPageProps {
  title?: string;
  message?: string;
  showHomeButton?: boolean;
  errorCode?: number | null;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  title = "เกิดข้อผิดพลาดบางอย่าง",
  message = "ขออภัยในความไม่สะดวก กรุณาลองใหม่อีกครั้งหรือติดต่อฝ่ายสนับสนุนหากยังพบปัญหา",
  showHomeButton = true,
  errorCode = 500,
}) => {
  if (String(errorCode) === '404') {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-b from-slate-50 to-blue-50">
        <div className="w-full max-w-2xl mx-4">
          <div className="bg-white rounded-lg shadow-lg p-8 flex flex-col items-center">
            <NotFoundGraphic />
            <h1 className="text-3xl md:text-4xl font-bold text-blue-700 text-center mb-3">ไม่พบหน้านี้</h1>
            <p className="text-slate-600 text-center mb-8 max-w-md mx-auto text-lg">
              ขออภัย ไม่พบหน้าที่คุณต้องการ<br />
              กรุณาตรวจสอบ URL หรือกลับสู่หน้าหลัก
            </p>
            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 w-full">
              <button
                onClick={() => window.location.href = '/'}
                className="w-full sm:w-auto px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium flex items-center justify-center gap-2"
              >
                <ChevronLeft className="h-4 w-4" />
                กลับสู่หน้าหลัก
              </button>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200 w-full">
              <p className="text-sm text-slate-500 text-center">
                รหัสข้อผิดพลาด: <span className="font-mono">404</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-b from-slate-50 to-blue-50">
      <div className="w-full max-w-2xl mx-4">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="flex justify-center mb-6">
            <AlertCircle className="h-16 w-16 text-blue-600" />
          </div>
          <h1 className="text-2xl md:text-3xl font-semibold text-slate-900 text-center mb-4">
            {title}
          </h1>
          <p className="text-slate-600 text-center mb-8 max-w-md mx-auto">
            {message}
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
            <button
              onClick={() => window.location.reload()}
              className="w-full sm:w-auto px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium flex items-center justify-center gap-2"
            >
              <RefreshCw className="h-4 w-4" />
              ลองใหม่อีกครั้ง
            </button>
            {showHomeButton && (
              <button
                onClick={() => window.location.href = '/'}
                className="w-full sm:w-auto px-6 py-2.5 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors duration-200 font-medium flex items-center justify-center gap-2"
              >
                <ChevronLeft className="h-4 w-4" />
                กลับสู่หน้าหลัก
              </button>
            )}
          </div>
          <div className="mt-8 pt-6 border-t border-slate-200">
            <p className="text-sm text-slate-500 text-center">
              รหัสข้อผิดพลาด: <span className="font-mono">{errorCode}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;